import { GameFrame } from '@/features/game-client/game-frame.tsx';
import { gameContextSelector } from '@/features/game-context/store/game-context.ts';
import { FgpPragmatic } from '@/features/providers/pragmatic/types.ts';
import { GameDataProp } from '@/features/providers/types.ts';
import { useAppSelector } from '@/store/hooks.ts';

export const Pragmatic: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const { gameName } = useAppSelector(gameContextSelector);
  const { url } = (data as FgpPragmatic).launchDetails;

  return <GameFrame title={gameName} url={url} />;
};
